/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PremiumDueBrokerOptionDto
 */
export interface PremiumDueBrokerOptionDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumDueBrokerOptionDto
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueBrokerOptionDto
     */
    name: string;
}

/**
 * Check if a given object implements the PremiumDueBrokerOptionDto interface.
 */
export function instanceOfPremiumDueBrokerOptionDto(value: object): value is PremiumDueBrokerOptionDto {
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PremiumDueBrokerOptionDtoFromJSON(json: any): PremiumDueBrokerOptionDto {
    return PremiumDueBrokerOptionDtoFromJSONTyped(json, false);
}

export function PremiumDueBrokerOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumDueBrokerOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'brokerId': json['brokerId'],
        'name': json['name'],
    };
}

export function PremiumDueBrokerOptionDtoToJSON(json: any): PremiumDueBrokerOptionDto {
    return PremiumDueBrokerOptionDtoToJSONTyped(json, false);
}

export function PremiumDueBrokerOptionDtoToJSONTyped(value?: PremiumDueBrokerOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brokerId': value['brokerId'],
        'name': value['name'],
    };
}

